import { useQuery, UseQueryOptions, useMutation, UseQueryResult } from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { QueryKeys } from './_query_keys'
import { HttpRequest } from '../services/_http'

// Widget-Types API Query

export const useGetWidgetTypesData = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.WIDGETS_TYPES, searchOptions]

    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.WidgetTypes}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        cacheTime: 0,
        ...options
    })
}

export const useGetWidgetData = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.WIDGET, searchOptions]

    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Widgets}`,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        cacheTime: 0,
        ...options
    })
}

export const useAddWidget = (options?: any) => {
    const method = 'POST'
    return useMutation(({ data }: { data: any }) => HttpRequest({
        url: `${APIEndpoints.Widgets}`,
        method,
        data
    }), options)
}

export const useAddWidgetTypes = (options?: any) => {

    const method = 'POST'
    return useMutation(({ data }: { data: any }) => HttpRequest({
        url: `${APIEndpoints.WidgetTypes}`,
        method,
        data
    }), options)
}

export const useUpdateWidgetTypes = (options?: any) => {

    const method = 'PUT'
    return useMutation(({ data, id }: { data: any, id: any }) => HttpRequest({
        url: `${APIEndpoints.WidgetTypes}/${id}`,
        method,
        data
    }), options)
}

export const useDeleteWidgetTypes = (options?: any) => {

    const method = 'DELETE'
    return useMutation(({ id }: { id: any }) => HttpRequest({
        url: `${APIEndpoints.WidgetTypes}/${id}`,
        method,
    }), options)
}

export const useStatusWidgetTypes = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({ data, id }: { data: FormData, id: any }) => HttpRequest({
        url: `${APIEndpoints.WidgetTypes}/${id}/status`,
        method,
        data
    }), options)
}


// Widgets API Query
export const useAddWidgets = (options?: any) => {

    const method = 'POST'
    return useMutation(({ data }: { data: any }) => HttpRequest({
        url: `${APIEndpoints.Widgets}`,
        method,
        data
    }), options)
}

export const useDeleteWidget = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({ id }: { id: any }) => HttpRequest({
        url: `${APIEndpoints.Widgets}/${id}`,
        method,
    }), options)
}

export const useUpdateStatusWidget = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({ data, id }: { data: any, id: any }) => HttpRequest({
        url: `${APIEndpoints.Widgets}/${id}/status`,
        method,
        data
    }), options)
}   

export const useUpdateWidgets = (options?: any) => {
    const method = 'PUT'
     return useMutation(({ data, id }: { data: any, id: any }) => HttpRequest({
        url: `${APIEndpoints.Widgets}/${id}`,
        method,
        data
    }), options)
}

export const useWidgetsDetails = (id: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.WIDGETS_DETAILS, id]
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Widgets}/${id}`,
            method
        }),
         enabled: !!id,
         refetchOnWindowFocus: false,
        ...options
    })
}

